import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { Page500 } from '@containers/ErrorPages';
import { dashboardApi } from '@reducers/dashboard/dashboard';

export const UserManual = () => {
  const { data, isLoading, isError } = dashboardApi.useGetUserManualDataQuery();
  return (
    <Card>
      <Card.Header className="text-center bg-didxl text-white">
        User Manual
      </Card.Header>
      <Card.Body>
        {isLoading ? <DefaultSpinnerCenter /> : null}
        {isError ? <Page500 /> : null}
        {!isLoading && !isError ? (
          <>
            {data.map(({ description, location }) => (
              <div key={description}>
                <Link to={location} className="normalFontSize" target="_blank">
                  {description}
                </Link>
              </div>
            ))}
          </>
        ) : null}
      </Card.Body>
    </Card>
  );
};
